import { stationTransformer } from "@/helpers";
import { getUserStations } from "@/services/UserService";

export const fetchProfileStations = async ({ commit }) => {
  const stations = await getUserStations();

  commit("setProfileStations", stations.map(stationTransformer()));
};
